import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Products", href: "#drama" },
  { label: "Business", href: "#business" },
  { label: "Partnership", href: "#partnership" },
  { label: "Contact", href: "#contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.nav
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        padding: "0 40px",
        height: 68,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: scrolled ? "rgba(8,8,8,0.95)" : "transparent",
        borderBottom: scrolled ? "1px solid rgba(255,255,255,0.07)" : "none",
        transition: "background 0.4s, border 0.4s",
      }}
    >
      {/* Logo */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        style={{ background: "none", border: "none", cursor: "pointer", display: "flex", alignItems: "center", gap: 8 }}
      >
        <span style={{ color: "#FF1C35", fontWeight: 900, fontSize: 24, letterSpacing: 2 }}>MIRE</span>
        <span style={{ color: "rgba(255,255,255,0.5)", fontWeight: 400, fontSize: 13, letterSpacing: 3, marginTop: 2 }}>MEDIA</span>
      </button>

      {/* Desktop Nav */}
      <div style={{ display: "flex", alignItems: "center", gap: 36 }} className="hidden-mobile">
        {NAV_LINKS.map((l) => (
          <button
            key={l.label}
            onClick={() => scrollTo(l.href)}
            style={{
              background: "none", border: "none", cursor: "pointer",
              color: "rgba(255,255,255,0.7)", fontSize: 14, fontWeight: 500,
              letterSpacing: 0.5, transition: "color 0.2s",
            }}
            onMouseEnter={e => (e.currentTarget.style.color = "#FF1C35")}
            onMouseLeave={e => (e.currentTarget.style.color = "rgba(255,255,255,0.7)")}
          >
            {l.label}
          </button>
        ))}
        <button
          onClick={() => scrollTo("#partnership")}
          style={{
            background: "#FF1C35", color: "#fff", border: "none",
            padding: "9px 22px", borderRadius: 6, fontSize: 13,
            fontWeight: 600, cursor: "pointer", letterSpacing: 0.5,
            transition: "opacity 0.2s",
          }}
          onMouseEnter={e => (e.currentTarget.style.opacity = "0.85")}
          onMouseLeave={e => (e.currentTarget.style.opacity = "1")}
        >
          Partner With Us
        </button>
      </div>

      {/* Mobile Menu Button */}
      <button
        className="show-mobile"
        onClick={() => setMenuOpen(!menuOpen)}
        style={{ background: "none", border: "none", cursor: "pointer", color: "#fff", fontSize: 22 }}
      >
        {menuOpen ? "✕" : "☰"}
      </button>

      {/* Mobile Dropdown */}
      {menuOpen && (
        <div style={{
          position: "absolute", top: 68, left: 0, right: 0,
          background: "rgba(12,12,12,0.98)", padding: "20px 24px",
          display: "flex", flexDirection: "column", gap: 16,
          borderBottom: "1px solid rgba(255,255,255,0.08)",
        }}>
          {NAV_LINKS.map(l => (
            <button key={l.label} onClick={() => scrollTo(l.href)}
              style={{ background: "none", border: "none", cursor: "pointer", color: "#fff", fontSize: 16, textAlign: "left" }}>
              {l.label}
            </button>
          ))}
        </div>
      )}

      <style>{`
        @media (max-width: 768px) { .hidden-mobile { display: none !important; } }
        @media (min-width: 769px) { .show-mobile { display: none !important; } }
      `}</style>
    </motion.nav>
  );
};

export default Navbar;
